import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	orderData: [],
};

const orderSlice = createSlice({
	name: "order",
	initialState,
	reducers: {
		orderStatistic: (state, action) => {
			state.orderData = action.payload;
		},
	},
});

export const { orderStatistic } = orderSlice.actions;

export default orderSlice.reducer;
